module.exports = __webpack_public_path__ + "static/media/yt-airhorn.a58d4d59.mov";